import Activity, {
  ActivityOptions,
  ActivityType,
  BaseActivityData,
  BaseActivityDataOptions,
  getDefaults as getActivityDefaults,
} from 'models/Activity';

export interface SafeReturnOptions extends ActivityOptions {
  type: ActivityType.SAFE_RETURN;
  data: Partial<BaseActivityDataOptions>;
}

export function getDefaults(): SafeReturnOptions {
  return {
    ...getActivityDefaults(),
    type: ActivityType.SAFE_RETURN,
  };
}

export default class SafeReturn extends Activity {
  declare type: ActivityType.SAFE_RETURN;
  declare data: BaseActivityData;

  constructor(options: Partial<SafeReturnOptions> = {}) {
    const opts = { ...getDefaults(), ...options };

    super(opts);
  }

  get typeLabel() {
    return 'Safe Return Update';
  }
}
